import ImageWrapper from "@/components/ImageWrapper";
import { AemHost } from "@/utils/constant";
import { useAppSelector } from "@/utils/hooks/reactUseCustomHooks";
import { Box } from "@dxp-feed/ui/Box";
import { Card, CardHeader } from "@dxp-feed/ui/Card";
import { Text } from "@dxp-feed/ui/Text";
import Link from "@/components/Link";

const ArticleCategoryList = () => {
  const items = useAppSelector(
    (state) => state.AemArticledataSlice.recipescategories
  );

  const renderCategoryCards = () =>
    Array.isArray(items) &&
    items.map((ele, index) => (
      <Box
        as="div"
        key={index + "q"}
        className="h-full bg-brandWhite shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)] rounded-lg overflow-hidden"
      >
        <Link
          key={index + ele?.label}
          href={ele?.link ?? "#"}
          passHref
          className="[&>div]:shadow-none"
        >
          <Card>
            <Text
              as="div"
              className="relative bg-gray-200 min-h-[126px] overflow-hidden pt-[75%] md:pt-[77%] xl:pt-[57%]"
              >
              <ImageWrapper
                src={AemHost + ele.image}
                alt={ele?.label}
                fill
                className="absolute top-0 left-0 object-cover"
                />
            </Text>
            <CardHeader className="border-none py-4 px-[18px]">
              <Text as="h2" className="text-base font-bold black">
                {ele?.label}
              </Text>
            </CardHeader>
          </Card>
        </Link>
      </Box>
    ));

  return (
    <Box as="div" className="pb-6">
      <Box
        as="div"
        className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-4 lg:grid-cols-2 xl:grid-cols-4 gap-6  w-full"
      >
        {items?.length ? renderCategoryCards() : null}
      </Box>
    </Box>
  );
};
export default ArticleCategoryList;
